import { Typography } from '@mui/material';
import { getPathObject } from './paths';
import { AppContext } from '@/contexts/app.context';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const Breadcrumbs = () => {
  const location = useLocation();
  const context = useContext(AppContext);
  const pathTitle = getPathObject(location.pathname);

  useEffect(() => {
    console.log('Location changed');
    context.setExtraTitle('');
  }, [location]);

  return (
    <Typography variant="h5" component="div" sx={{ flexGrow: 1, fontFamily: 'Bungee Spice' }}>
      {pathTitle} {context.extraTitle}
      {!pathTitle && !context.extraTitle ? 'Witness the Fitness' : ''}
    </Typography>
  );
};
